import React from 'react';

import styled from '@emotion/styled';

import LeftCheveron from '../Icons/LeftCheveron';
import { SpinningIcon } from '../SpinningIcon/SpinningIcon';
import { IButton } from './interface';

const PrimaryButton: React.FC<IButton> = ({
  children,
  className,
  arrowIcon,
  onClick,
  disabled = false,
}) => {
  return (
    <StyledButton
      className={className ? className : ''}
      onClick={onClick}
      disabled={disabled}
    >
      {children} {arrowIcon && <LeftCheveron />}
    </StyledButton>
  );
};

export default PrimaryButton;

export const SecondaryButton: React.FC<IButton> = ({
  children,
  className,
  arrowIcon,
  onClick,
  disabled = false,
}) => {
  return (
    <StyledSecButton
      className={className ? className : ''}
      onClick={onClick}
      disabled={disabled}
    >
      {children} {arrowIcon && <LeftCheveron />}
    </StyledSecButton>
  );
};

const StyledSecButton = styled.button`
  color: ${({ theme }) => theme.palette.primaryButtonColor};
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  padding: 1rem 2.5rem 1rem 2.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;

  &:disabled {
    background-color: #fab89e;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const StyledButton = styled.button`
  color: ${({ theme }) => theme.palette.white};
  background: ${({ theme }) => theme.palette.primaryFocused};
  border: 1px solid transparent;
  border-radius: 0.25rem;
  padding: 1rem 2.5rem 1rem 2.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;

  &:disabled {
    background-color: #fab89e;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

interface IFormSubmitButton {
  iconColor?: string;
  iconSize?: string;
  showIcon?: boolean;
  children: string;
  width?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  cheveronIcon?: boolean;
  // onClick?: (...args: any) => any;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const FormSubmitButton: React.FC<IFormSubmitButton> = ({
  iconColor,
  iconSize,
  showIcon,
  children,
  className,
  type,
  disabled,
  onClick,
  cheveronIcon,
  width,
}) => {
  return (
    <FormSubmitBtn
      type={type}
      disabled={disabled}
      className={className ? className : ''}
      onClick={onClick}
    >
      {children} {!showIcon && cheveronIcon && <LeftCheveron />}
      {showIcon ? (
        <SpinningIcon color={iconColor || 'white'} size={Number(iconSize)} />
      ) : (
        ''
      )}
    </FormSubmitBtn>
  );
};

export const FormSubmitBtn = styled.button`
  background: ${({ theme }) => theme.palette.primaryFocused};
  font-weight: 600;
  font-size: 1rem;
  color: white;
  border: 1px solid transparent;
  cursor: pointer;
  margin: 2rem auto;
  /* for the spinner */
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 0.25rem;
  padding: 1rem 1.5rem;
  width: fit-content;

  &.horizontalSubmitBtn {
    margin-top: 1.8rem;

    @media (max-width: 480px) {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;
